import { render } from "./users-page.vue?vue&type=template&id=0da0294a"
import script from "./users-page.vue?vue&type=script&lang=js"
export * from "./users-page.vue?vue&type=script&lang=js"
script.render = render

export default script